
<div class="row" *ngIf="Breadcrumb!=null">
  <div class="col-12 p-0 border-bottom headersize">
    <app-breadcrumb [Breadcrumb]="Breadcrumb" [File_Name]="File_Name"></app-breadcrumb>
  </div>
</div>
<div class="row">
  <div class="col-12" style="height: 85vh !important;max-width: 100% !important; overflow: auto;">
    <div class="row pt-1">



          <div class="col-10" >
            <div class="row">
              <div class="col-12" *ngIf="FileType!='Video'" style="height: 81vh !important; overflow: auto;">
                <div class="row">
                  <div class="col-12">
                    <div class="card pl-1" >
                      <div class="card-body p-1" *ngIf="urlSafe">

                        <!-- <ngx-doc-viewer  [url]="urlSafe"  [viewer]="viewer"   style="width:885px; height: 75vh !important; overflow: auto;" disableContent='popout-hide' (contextmenu)="onRightClick()"></ngx-doc-viewer> -->
                        <div class="no-print" disableContextMenu>

                          <pdf-viewer [src]="urlSafe"
                                        [render-text]="true"
                                        [original-size]="false"
                                        [fit-to-page]="true"
                                        style="height: 74vh;border-bottom: 1px solid #c8c3c3;"
                                        [external-link-target]="'blank'"
                                        [autoresize]="true"
                                        [zoom-scale]="'page-width'"
                                        [zoom]="zoom_scale"
                                        [render-text-mode]="0"
                                        [show-borders]="true"
                                        [rotation]="Rotate"
                            ></pdf-viewer>


                            </div>
                            <div class="row">
                              <div class="col-12 pt-1">
                                <div class="row">


                                <div class="col-4">
                                  <div class="d-flex justify-content-start">


                                    <div class="px-1" >
                                      <button type="button" class="btn btn-sm" (click)="Rotation()">Rotate</button>
                                    </div>








                                  </div>
                                </div>

                                  <div class="col-4">
                                    <div class="d-flex justify-content-center">


                                      <div class="px-1" >
                                        <button type="button" class="btn btn-sm" (click)="zoom(0)">- zoom</button>
                                      </div>



                                      <div class="px-1">
                                        <button type="button" class="btn btn-sm" (click)="zoom(1)">+ zoom</button>
                                      </div>




                                    </div>
                                  </div>
                                  <div class="col-4">
                                    <div class="d-flex justify-content-end">
                                    <div class="px-1">
                                      <button type="button" class="btn btn-sm" (click)="clkclosebutton('Submitted')">Close</button>

                                    </div>
                                  </div>
                                  </div>

                              </div>
                              </div>
                            </div>

                            <!-- <button type="button" class="btn btn-sm" (click)="zoom(0)">-</button>zoom
                            <button type="button" class="btn btn-sm" (click)="zoom(1)">+</button>
                            <button type="button" class="btn btn-sm" (click)="Rotation()">Rotate</button>  -->

                      </div>
                      <div class="card-body p-1 text-center headersize" *ngIf="!urlSafe">No Preview
                      </div>
                    </div>
                  </div>

                </div>

              </div>
              <div class="col-12" *ngIf="FileType=='Video'"  style="height: 81vh !important; overflow: auto;">
                <div class="row">
                  <div class="col-12">
                    <div class="card pl-1">
                      <div class="card-body p-1" *ngIf="urlSafe1">

                        <iframe  *ngIf="File_Name=='External URL'" style="height: 70vh;width:100%;border-bottom: 1px solid #c8c3c3;" [src]="urlSafe1" frameborder="0">

                        </iframe>
                        <video *ngIf="File_Name!='External URL'" controls class="col-12" style="height: 70vh;width:100%;border-bottom: 1px solid #c8c3c3;;user-select: none;" oncontextmenu="return false;" controlsList="nofullscreen nodownload noremoteplayback noplaybackrate foobar" (click)="toggleVideo()" #videoPlayer>
                          <source style="user-select: none;" [src]="urlSafe1" type="video/mp4" />
                          <source style="user-select: none;" [src]="urlSafe1" type="video/ogg" />
                          <source style="user-select: none;" [src]="urlSafe1" type="video/mov" />
                          Browser not supported
                      </video>

                      </div>
                      <div class="card-body p-1 text-center headersize" *ngIf="!urlSafe1">No Preview
                      </div>
                    </div>
                  </div>

                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="d-flex justify-content-center pt-1 pb-1">

                      <div class="px-1">
                        <button type="button" class="btn btn-sm bg-light border" (click)="clkclosebutton('Submitted')">Close</button>

                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
          <div class="col-2">

          </div>
            <!-- <div class="row">
              <div class="col-12" >

              </div>

            </div> -->


            <!-- <div class="col-12">
              <div class="d-flex justify-content-center pt-1 pb-1">


              </div>
            </div> -->
          </div>

          <!-- <div class="col-2">

          </div> -->


        </div>

      </div>






